import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import NoMatch from "./pages/Nomatch";
import routes from "./routes";
import authInterceptor from "./axios/interceptors/authInterceptor";
import responseInterceptor from "./axios/interceptors/responseInterceptor";
import * as amplitude from "@amplitude/analytics-browser";
import Dashboard from "./layouts/Dashboard";
import AuthLayout from "./layouts/Auth";
import GlobalSnackbar from "./components/GlobalSnackbar";
import useGlobalStore from "./store/useGlobalStore";
import LoaderWrapper from "./components/Loaders/LoaderWrapper";

if (process.env.NODE_ENV === "production") {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY, {
    defaultTracking: true,
  });
}

authInterceptor();
responseInterceptor();

function App() {
  const initApplication = useGlobalStore((state) => state.initApplication);
  const configLoading = useGlobalStore((state) => state.configLoading);
  const applicationInitialized = useGlobalStore(
    (state) => state.applicationInitialized,
  );

  useEffect(() => {
    initApplication();
  }, []);

  return (
    <div className="App">
      {!applicationInitialized || configLoading ? (
        <div style={{ width: "100%", height: "100vh", background: "#f7f9fc" }}>
          <LoaderWrapper text="User Data" />
        </div>
      ) : (
        <Switch>
          {routes.map((route) =>
            route.needsAuth ? (
              <Route
                key={route.path}
                path={route.path}
                exact={route.exact}
                render={(props) => (
                  <Dashboard>
                    <Route
                      component={route.component}
                      path={route.path}
                      {...route}
                      {...props}
                    />
                  </Dashboard>
                )}
              />
            ) : (
              <Route
                key={route.path}
                path={route.path}
                exact={route.exact}
                render={(props) => (
                  <AuthLayout>
                    <Route
                      component={route.component}
                      path={route.path}
                      {...route}
                      {...props}
                    />
                  </AuthLayout>
                )}
              />
            ),
          )}
          <Route component={NoMatch} />
        </Switch>
      )}
      <GlobalSnackbar />
    </div>
  );
}

export default App;
